import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import connect from '../store/connect';
import RadioButton from '../components/RadioButton';
import { size } from '../styles/helpers/variables';
import { toCurrency } from '../util/toCurrency';

const DeliveryRow = props => (
  <DeliveryRowWrapper>
    <RadioButton
      id={props.id}
      name="DeliveryRow"
      defaultChecked={props.defaultChecked === props.id}
      value={props.id}
      checked={props.id === props.activeValue}
      onChange={event => {
        props.onChange(event);
      }}
    >
      <div>
        <DeliveryRowTitle>
          {props.title}
          {props.viewstate.get('pageWidth') < size.large ? ` - ${toCurrency(props.cost)}` : false}
        </DeliveryRowTitle>
        <DeliveryRowText>{props.text}</DeliveryRowText>
      </div>
      {props.viewstate.get('pageWidth') >= size.large ? (
        <DeliveryRowPrice>{toCurrency(props.cost)}</DeliveryRowPrice>
      ) : (
        false
      )}
    </RadioButton>
  </DeliveryRowWrapper>
);

const DeliveryRowWrapper = styled.div`
  display: block;
  margin: 38px 0;
`;

const DeliveryRowTitle = styled.div`
  margin-left: 18px;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  display: block;
  color: #000000;
`;

const DeliveryRowText = DeliveryRowTitle.extend`
  font-weight: normal;
  font-style: italic;
`;

const DeliveryRowPrice = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: right;
  display: inline-block;
  flex: 1;
  min-width: 60px;
  color: #000000;
`;

DeliveryRow.defaultProps = {
  title: null,
  text: null,
  cost: null,
  defaultChecked: false,
  viewstate: Map(),
  onChange: () => {},
  activeValue: undefined,
};

DeliveryRow.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  cost: PropTypes.number,
  defaultChecked: PropTypes.bool,
  viewstate: PropTypes.instanceOf(Map),
  onChange: PropTypes.func,
  activeValue: PropTypes.string,
};

export default connect(DeliveryRow, {}, store => ({
  viewstate: store.viewstate
}));



// WEBPACK FOOTER //
// ./src/components/DeliveryRow.js